import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  Form,
  Input,
  Row,
  Col,
  Typography,
  Spin,
  Tabs,
} from "antd";
import { EditOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { createOrg, fetchOrg, updateOrg } from "../../Redux/Slice/Admin/Org";
import { toast } from "react-toastify";

import Branches from "./Branches"; // ✅ new component
import Specialties from "./Specialties"; // ✅ existing component

const { Title } = Typography;
const { TabPane } = Tabs;

const Org = () => {
  const dispatch = useDispatch();

  const [orgDetails, setOrgDetails] = useState([]);
  const [orgModalOpen, setOrgModalOpen] = useState(false);
  const [orgForm] = Form.useForm();
  const [orgId, setOrgId] = useState(null);

  console.log("orgDetails", orgDetails);

  useEffect(() => {
    dispatch(fetchOrg());
  }, [dispatch]);

  const {
    data: orgData,
    loading,
    error,
    createData,
    createLoading,
    createError,
    updateData,
    updateLoading,
    updateError,
  } = useSelector((state) => state.org);

  useEffect(() => {
    if (orgData) {
      setOrgDetails(orgData);
      setOrgModalOpen(false);

      setOrgId(orgData[0]?.id || null);

      if (orgData.status === true) {
        toast.success(orgData.message || "Organization saved successfully!");
      } else if (orgData.status === false) {
        toast.error(orgData.message || "Something went wrong!");
      }
    }

    if (error) {
      toast.error(error || "Something went wrong!");
    }
  }, [orgData, error]);

  // ---- Org Create ----
  const handleOrgSave = () => {
    orgForm.validateFields().then((values) => {
      dispatch(createOrg(values)).then(() => {
        orgForm.resetFields();
        dispatch(fetchOrg());
      });
    });
  };

  // ---- Org Update ----
  const handleOrgUpdate = () => {
    orgForm.validateFields().then((values) => {
      dispatch(updateOrg({ ...values, id: orgId })).then(() => {
        setOrgModalOpen(false);
        dispatch(fetchOrg());
      });
    });
  };

  // ✅ Toast for create status
  useEffect(() => {
    if (createData?.status) {
      if (createData.status === true) {
        toast.success(createData.message || "Organization saved successfully!");
      } else if (createData.status === false) {
        toast.error(createData.message || "Something went wrong!");
      }
    }

    if (createError) {
      toast.error(createError || "Something went wrong!");
    }
  }, [createData, createError]);

  // ✅ Toast for update status
  useEffect(() => {
    if (updateData?.status) {
      if (updateData.status === true) {
        toast.success(
          updateData.message || "Organization updated successfully!"
        );
      } else if (updateData.status === false) {
        toast.error(updateData.message || "Something went wrong!");
      }
    }

    if (updateError) {
      toast.error(updateError || "Something went wrong!");
    }
  }, [updateData, updateError]);

  return (
    <div style={{ padding: "20px", background: "#fff", borderRadius: "10px" }}>
      {loading ? (
        // ---- Loading spinner ----
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "80vh",
          }}
        >
          <Spin size="large" />
        </div>
      ) : (
        <>
          {orgDetails.length === 0 ? (
            // ---- If no org, show create form ----
            <div
              style={{
                maxWidth: 500,
                margin: "20px auto",
                background: "#fafafa",
                padding: 20,
                borderRadius: 8,
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              }}
            >
              <Title level={3} style={{ textAlign: "center" }}>
                Create Organization
              </Title>
              <Form form={orgForm} layout="vertical">
                <Row gutter={16}>
                  <Col span={24}>
                    <Form.Item
                      name="hospitalName"
                      label="Hospital Name"
                      rules={[{ required: true }]}
                    >
                      <Input placeholder="Enter Hospital Name" />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="noOfBranches"
                      label="Number of Branches"
                      rules={[{ required: true }]}
                    >
                      <Input
                        type="number"
                        placeholder="Enter Number of Branches"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="postalCode"
                      label="Postal Code"
                      rules={[{ required: true }]}
                    >
                      <Input placeholder="Enter Postal Code" />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      name="address"
                      label="Address"
                      rules={[{ required: true }]}
                    >
                      <Input placeholder="Enter Address" />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="district"
                      label="District"
                      rules={[{ required: true }]}
                    >
                      <Input placeholder="Enter District" />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="city"
                      label="City"
                      rules={[{ required: true }]}
                    >
                      <Input placeholder="Enter City" />
                    </Form.Item>
                  </Col>
                </Row>
                <Button
                  type="primary"
                  onClick={handleOrgSave}
                  block
                  createLoading={createLoading}
                >
                  {createLoading ? "Loading..." : "Create"}
                </Button>
              </Form>
            </div>
          ) : (
            <>
              {/* ---- Org Header ---- */}
              {orgDetails.map((org) => (
                <div
                  key={org.id}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 20,
                  }}
                >
                  <Title level={3} style={{ margin: 0 }}>
                    {org.hospitalName}
                  </Title>
                  <Button
                    type="default"
                    icon={<EditOutlined />}
                    onClick={() => {
                      orgForm.setFieldsValue(org);
                      setOrgModalOpen(true);
                    }}
                  >
                    Edit
                  </Button>
                </div>
              ))}

              {/* ---- Tabs ---- */}
              <Tabs defaultActiveKey="1">
                <TabPane tab="Branches" key="1">
                  <Branches orgDetails={orgDetails} />{" "}
                  {/* ✅ Branches moved out */}
                </TabPane>
                <TabPane tab="Specialties" key="2">
                  <Specialties />
                </TabPane>
              </Tabs>
            </>
          )}

          {/* ---- Org Edit Modal ---- */}
          <Modal
            title="Edit Organization Details"
            open={orgModalOpen}
            onCancel={() => setOrgModalOpen(false)}
            onOk={handleOrgUpdate}
            okText="Save"
            confirmLoading={updateLoading}
          >
            <Form form={orgForm} layout="vertical">
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item
                    name="hospitalName"
                    label="Hospital Name"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Enter Hospital Name" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="noOfBranches"
                    label="Number of Branches"
                    rules={[{ required: true }]}
                  >
                    <Input
                      type="number"
                      placeholder="Enter Number of Branches"
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="postalCode"
                    label="Postal Code"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Enter Postal Code" />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="address"
                    label="Address"
                    rules={[{ required: false }]}
                  >
                    <Input placeholder="Enter Address" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="district"
                    label="District"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Enter District" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="city"
                    label="City"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Enter City" />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Modal>
        </>
      )}
    </div>
  );
};

export default Org;
